import { render, staticRenderFns } from "./DialogComoFunciona.vue?vue&type=template&id=2ec99e54&scoped=true"
import script from "./DialogComoFunciona.vue?vue&type=script&lang=js"
export * from "./DialogComoFunciona.vue?vue&type=script&lang=js"
import style0 from "./DialogComoFunciona.vue?vue&type=style&index=0&id=2ec99e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec99e54",
  null
  
)

export default component.exports